import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiArrowLeft } = FiIcons;

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link to="/" className="inline-flex items-center text-blue-600 hover:text-blue-700 mb-8 transition-colors">
            <SafeIcon icon={FiArrowLeft} className="w-4 h-4 mr-2" />
            Volver al inicio
          </Link>

          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-8">Política de Privacidad</h1>
            
            <div className="space-y-6 text-gray-700">
              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Responsable del Tratamiento</h2>
                <p className="mb-3">
                  Los datos personales facilitados serán tratados por:
                </p>
                <ul className="list-none pl-4 space-y-1 text-sm bg-gray-50 p-4 rounded border border-gray-100">
                  <li><strong>Titular:</strong> ÁNGEL SEISDEDOS GAVIRA</li>
                  <li><strong>NIF:</strong> 45.660.354-H</li>
                  <li><strong>Domicilio:</strong> Calle Miguel Vázquez Delgado, 3ºC, San José de la Rinconada, Sevilla, España</li>
                  <li><strong>Email:</strong> angel@leggado.es</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">2. Finalidad del Tratamiento</h2>
                <p className="mb-3">Recopilamos su información personal para las siguientes finalidades:</p>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Gestionar su registro y cuenta de usuario en NormaAlerta.</li>
                  <li>Enviar boletines diarios o semanales sobre actualizaciones normativas del BOE, según sus preferencias.</li>
                  <li>Gestionar la facturación y cobro de los servicios Premium (Plan Pro).</li>
                  <li>Atender sus consultas y solicitudes de soporte.</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Legitimación</h2>
                <p>
                  La base legal para el tratamiento de sus datos es:
                </p>
                <ul className="list-disc pl-6 space-y-1 mt-2">
                  <li>La ejecución del contrato de suscripción (Términos de Servicio).</li>
                  <li>Su consentimiento explícito para el envío de comunicaciones.</li>
                  <li>El cumplimiento de obligaciones legales (facturación e impuestos).</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Destinatarios</h2>
                <p>
                  No cederemos sus datos a terceros, salvo obligación legal. No obstante, utilizamos proveedores de servicios (encargados del tratamiento) como:
                </p>
                <ul className="list-disc pl-6 space-y-1 mt-2">
                  <li>Plataforma de Email Marketing (ej. Mailgun/Acumbamail).</li>
                  <li>Pasarela de pagos (ej. Stripe).</li>
                  <li>Servicios de alojamiento web y base de datos (ej. Supabase).</li>
                </ul>
              </section>

              <section>
                <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Derechos</h2>
                <p className="mb-3">
                  Puede ejercer sus derechos de acceso, rectificación, supresión, oposición y portabilidad enviando un email a <strong>angel@leggado.es</strong>, adjuntando copia de su DNI.
                </p>
              </section>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-8">
                <p className="text-sm text-blue-800">
                  <strong>Última actualización:</strong> Enero 2026
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;